import { api } from '..';

export const downloadXlsxFile = async (id: string) => {
  const buffer = await api.get<ArrayBuffer>(
    `/pricingsheets/xlsx/${id}`,
    { responseType: 'arraybuffer' },
  );
  return buffer;
};

export const downloadXlsxKitFile = async (id: string) => {
  const buffer = await api.get<ArrayBuffer>(
    `/pricingsheets/xlsx-kit/${id}`,
    { responseType: 'arraybuffer' },
  );
  return buffer;
};
